
import { Outlet, useNavigate } from "react-router-dom";
import { Sidebar } from "components/Sidebar";
import { createPortal } from "react-dom";
import { ContextMenu } from "components/ContextMenu";
import { MSContext } from "services/ms";

export default function PainelLayout() {
    return (
      <MSContext>
        <div className='min-h-screen bg-zinc-100'>
          <Sidebar/>
          <div className='pl-64 p-8 min-h-screen h-full flex w-full overflow-x-auto'>
            <Outlet/>
          </div>
          {createPortal(
            <ContextMenu />,
            document.body,
          )}
        </div>
      </MSContext>
    )
}